import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {Department} from 'typings/portaro.be.types';

export default class ServerUrlsDataService {
    public static readonly serviceName = 'serverUrlsDataService';

    private static readonly SERVER_URLS_ROUTE = 'server-urls';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getDepartmentUrl(): Promise<{[url: string]: Department}> {
        return this.Restangular
            .one(ServerUrlsDataService.SERVER_URLS_ROUTE)
            .get();
    }
}